export const ENABLE_PAGE_NOT_FOUND = 'page/PAGE_NOT_FOUND [enable]';
export const ACTIVATE_PAGE_NOT_FOUND = 'page/PAGE_NOT_FOUND [activate]';
